export default {"src":"/_next/static/media/OV-binnen-200m.bae6247e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};